import type { LogEventValue } from '../types';

/**
 * Creates a namespaced log event with type safety
 *
 * @param namespace - The event namespace (e.g., 'security.authn', 'api.learningActivity')
 * @param event - The specific event name (e.g., 'login_fail', 'created')
 * @returns A branded LogEventValue string
 *
 * @example
 * const event = createLogEvent('api.learningActivity', 'draft.created');
 * // Returns: 'api.learningActivity.draft.created' as LogEventValue
 */
export function createLogEvent(namespace: string, event: string): LogEventValue {
  return `${namespace}.${event}` as LogEventValue;
}

/**
 * Alternative: Create event builder for convenience
 * Useful for creating multiple events in the same namespace
 *
 * @param namespace - The event namespace
 * @returns An object with an event() method
 *
 * @example
 * const learningActivity = createEventNamespace('api.learningActivity.draft');
 * learningActivity.event('created') // 'api.learningActivity.draft.created'
 * learningActivity.event('updated') // 'api.learningActivity.draft.updated'
 */
export function createEventNamespace(namespace: string) {
  return {
    event: (name: string) => createLogEvent(namespace, name)
  };
}
